"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const growthbook_react_1 = require("@growthbook/growthbook-react");
const runtime_config_1 = require("../config/runtime-config");
const FeatureFlagsProvider = ({ children, growthbook: externalGrowthbook, }) => {
    const [gb, setGb] = (0, react_1.useState)(() => {
        // Si hay instancia externa, usarla
        if (externalGrowthbook) {
            return externalGrowthbook;
        }
        // Crear instancia inicial sin clientKey (para que el provider exista desde el inicio)
        return new growthbook_react_1.GrowthBook({ enableDevMode: true });
    });
    const isExternalRef = (0, react_1.useRef)(!!externalGrowthbook);
    const initializedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        // Si es instancia externa o ya inicializamos, no hacer nada
        if (isExternalRef.current || initializedRef.current) {
            return;
        }
        initializedRef.current = true;
        let config;
        try {
            config = (0, runtime_config_1.getConfig)();
        }
        catch {
            console.warn('[FeatureFlags] Config not ready');
            return;
        }
        const clientKey = config.GROWTHBOOK_CLIENT_KEY;
        // DEBUG: Exponer en window para verificar en staging
        if (typeof window !== 'undefined') {
            ;
            window.__GB_DEBUG__ = {
                clientKey,
                env: config.ENV,
                configLoaded: true,
            };
        }
        if (!clientKey) {
            console.warn('[FeatureFlags] No clientKey configured, skipping CDN fetch');
            return;
        }
        // Destruir instancia inicial y crear una nueva con clientKey
        gb.destroy();
        const newGb = new growthbook_react_1.GrowthBook({
            clientKey,
            attributes: { env: config.ENV },
            enableDevMode: config.ENV !== 'production',
        });
        // DEBUG: Exponer instancia en window
        if (typeof window !== 'undefined') {
            ;
            window.__GROWTHBOOK__ = newGb;
        }
        newGb
            .loadFeatures()
            .then(() => {
            setGb(newGb);
        })
            .catch((e) => {
            console.warn('[FeatureFlags] Failed to load features:', e);
            // Aún así establecer la instancia para no bloquear la app
            setGb(newGb);
        });
    }, [gb]);
    // Cleanup
    (0, react_1.useEffect)(() => {
        return () => {
            if (!isExternalRef.current) {
                gb.destroy();
            }
        };
    }, [gb]);
    return (0, jsx_runtime_1.jsx)(growthbook_react_1.GrowthBookProvider, { growthbook: gb, children: children });
};
exports.FeatureFlagsProvider = FeatureFlagsProvider;
